import moneyTypeReducer from './money-type';
export * from './money-type';

export default { moneyType: moneyTypeReducer };
